import { useMemo, useRef } from 'react'
import './featured-elements-list.styles.scss'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAward,
  faCube,
  faCubesStacked,
  faDice,
  faFlagCheckered,
  faGift,
  faGlobeAmericas,
  faMapLocationDot,
  faPiggyBank,
  faStairs,
  faStar
} from '@fortawesome/free-solid-svg-icons'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import {
  buildPlayerFeaturedList,
  getFeaturedDetail,
  getFeaturedLink,
  getFeaturedTypeKey,
  getFeaturedTypeLabel,
  truncateDesc
} from '@/utils/featuredElements'

const typeIcons = {
  'challenge': faFlagCheckered,
  'quest': faMapLocationDot,
  'badge': faAward,
  'level': faStairs,
  'collection': faCubesStacked,
  'inventory': faDice,
  'realworld': faGlobeAmericas,
  'contribution': faPiggyBank,
  'collectible': faCube,
  'prizepack': faGift,
}

const FeaturedElementsList = ({
  gameData,
  playerData,
  gameElements,
  gameStats,
  teamMembers
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const navigate = useNavigate();
  const randomOrderRef = useRef({});
  const isSmallScreen = screenSize === 'mobile' || screenSize === 'tablet';

  const featuredList = useMemo(() => (
    buildPlayerFeaturedList({
      gameData,
      gameElements,
      playerData,
      gameStats,
      teamMembers,
      'randomOrder': randomOrderRef.current
    })
  ), [gameData, gameElements, playerData, gameStats, teamMembers])

  if (featuredList.length === 0) {
    return (
      <div className='no-featured'>
        No featured items at this time. Check back later!
      </div>
    )
  }

  return (
    <div className={`featured-elements-list ${screenSize} ${isSmallScreen ? 'small-screen' : ''}`}>
      <table className='g-table no-header'>
        <tbody>
          {
            featuredList.map(element => {
              const link = getFeaturedLink(element, gameData);
              const detail = getFeaturedDetail(element);
              const typeKey = getFeaturedTypeKey(element);
              return (
                <tr
                  key={element.id}
                  className={`featured-element type-${typeKey} ${link ? 'clickable' : ''}`}
                  onClick={link ? () => navigate(link) : null}
                >
                  <td className='icon-td'>
                    <ImageContainer
                      src={element.icon}
                      alt={`${element.name} icon`}
                      className='featured-element-icon' />
                  </td>
                  <td className='featured-element-info'>
                    <div className='title-row'>
                      <div className='title'>
                        {
                          (element.isChosen) &&
                          <FontAwesomeIcon icon={faStar} className='chosen-star' title='Featured' />
                        }
                        {element.name}
                      </div>
                      <span className='type-badge' title={getFeaturedTypeLabel(element)}>
                        <FontAwesomeIcon icon={typeIcons[typeKey]} />
                        {!isSmallScreen && getFeaturedTypeLabel(element)}
                      </span>
                    </div>
                    {
                      (detail) &&
                      <div className='detail'>{detail}</div>
                    }
                    {
                      (element.desc) &&
                      <div className='meta'>{truncateDesc(element.desc)}</div>
                    }
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  )
}

export default FeaturedElementsList
